/**
 * Handles transition between slides
 * @module embed/transition_slide
 */

import { takeover } from './transition_slide/takeover';
import { replace } from './transition_slide/replace';

const ATTR_TRANSITION_TYPE = 'data-transition-type';
const DEFAULT_TRANSITION_TYPE = 'replace';

const TRANSITIONS = {
  // Takeover
  takeover,
  // Redirects to the backend form preview
  redirect(newForm) {
    const formUrl = `${newForm.action}/edit?slide_id=${newForm.slide_id.value}`;
    window.location = formUrl;
    return Promise.resolve();
  },
  // Replace current form with the new form
  replace
};

/**
 * Transitions between the old and new form according to the transition
 * defined on the new form
 * @param {HTMLElement} newForm The new form
 * @param {HTMLElement} oldForm The old form
 * @param {Function} context.beforeEnter A callback that will be run before the new form enters the DOM
 */
export function transitionSlide(newForm, oldForm, context) {
  const transitionType =
    newForm.getAttribute(ATTR_TRANSITION_TYPE) || DEFAULT_TRANSITION_TYPE;
  const transition =
    TRANSITIONS[transitionType] || TRANSITIONS[DEFAULT_TRANSITION_TYPE];
  return transition(newForm, oldForm, context);
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/transition_slide.js